// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"401":"prices","962":"home"}[chunkId] + ".css";
};